import { signal } from '@preact/signals-react'

export const currentRoast = signal({})